import React from "react";
import { Dimensions, StyleSheet, View } from "react-native";
import color from "@constants/color";
import Text from "@components/CustomText";
interface ResultSubCardProps {
  extra_info: any;
  result: any;
}

const ResultSubCard: React.FC<ResultSubCardProps> = ({
  extra_info,
  result,
}) => {
  return (
    <View style={styles.summaryContainer}>
      {extra_info?.map((item: any) => (
        <View key={item?.title} style={styles.listItem}>
          <Text variant="caption_2" style={styles.textstyle}>
            {item.title}
          </Text>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            {item?.rating_txt && (
              <Text
                variant="caption_4"
                style={{
                  marginRight: 8,
                  color: item?.rating_color,
                  lineHeight: 18,
                }}
              >
                {item.rating_txt}
              </Text>
            )}
            <Text variant="body_text_2">{item.value}</Text>
          </View>
        </View>
      ))}
      <View style={{ height: 30 }}>
        <View style={styles.resultContainer}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text variant="caption_4" style={styles.textstyle}>
              {result?.title}
            </Text>
            <Text
              variant="caption_3"
              style={{ color: color.lightMediumBlack, marginLeft: 2 }}
            >
              {result?.subtitle}
            </Text>
          </View>
          <Text variant="body_text_2">{result?.value}</Text>
        </View>
      </View>
    </View>
  );
};

export default ResultSubCard;

const styles = StyleSheet.create({
  summaryContainer: {
    backgroundColor: color.white,
    borderRadius: 16,
  },
  listItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 4,
    borderRadius: 16,
    alignItems: "center",
  },
  textstyle: {
    color: color.black06,
  },
  resultContainer: {
    backgroundColor: "#F5F8FA",
    flexDirection: "row",
    justifyContent: "space-between",
    overflow: "hidden",
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    position: "absolute",
    width: Dimensions.get("screen").width - 42,
    bottom: -8,
    left: -12,
  },
});
